@if (!loading) {
  <section>
    <app-client-task-nav [baseUrl]="navBaseUrl" />
    <div><app-client-consult-note-task-header [task]="task" [displayUserPresence]="displayUserPresence" /></div>
    <app-patient-prescriber-active-note [patientPrescriberId]="task.patientPrescriberId" />
    <div class="row m-0 p-0 mt-3 mb-5">
      <div class="col p-0">
        <app-client-consult-note-task-verification
          [task]="task"
          [formDisabled]="formDisabled"
          (taskChange)="onTaskChange($event)" />
      </div>
      <div class="col"><app-client-consult-note-task-details [task]="task" /></div>
    </div>
  </section>
} @else {
  <mat-spinner />
}
